let limit = 2;
let current_step = 0;
let allowAddToCart = false;

//elements
let set_of_options = $('.set-of-options');
let main_flavor_selector = $('input.flavor-one-option');
let icing_flavor_selector = $('input.border-icing-option');
let text_area_message = $(".text-area-cake-message");
let cake_message_flavor_selector = $('.message-icing-flavor-select');
let back_button = $('#cookie-maker-back-btn');
let continue_button = $('#cookie-maker-continue-btn');

//values
let flavors = [];
let cake_message = $('.text-area-cake-message').val();
let border_icing_flavors = [];
let cake_message_flavor = null;

//Start script
goToStep(current_step);

//FUNCTIONS
function limitSelectingOptions(input,evt){
  if (input.siblings(':checked').length >= limit) {
	input.not(':checked').prop('disabled', true);
  }else{
  	input.prop('disabled', false);
  }	
}

function validateAddToCart(){
  allowAddToCart = false;
  if (cake_message.length > 1) {
    if(cake_message_flavor !== null){
      allowAddToCart = true;

    }
  }
  toggleAddToCart();
}

function toggleAddToCart(){  
  if(allowAddToCart === true){
    $(".product-form__submit ").removeAttr('disabled');
  }  else{
    $(".product-form__submit ").attr('disabled', 'disabled');
  }  
}

function goToStep(step) {

  current_step = step;
  if (step !== 3){
    $('#cookie-maker-continue-btn').show();
    $('body[class~="template_product.custom-cookie-cake"] .product-form__buttons').hide();
  }
  set_of_options.hide();
  $('.set-of-options[rel="' + step + '"]').show();

  if (current_step === 0) {
    $('#cookie-maker-back-btn').hide();
    $('variant-radios').show();
  }
  if (current_step === 1) {
    $(".product__description").hide();
    $('#cookie-maker-back-btn').show();
    $('variant-radios').hide();
  }

  if(current_step === 2){
    $('.border-icing-flavors-error').html(' ');
    $('.border-icing-flavors-error').css('visibility', 'hidden');
  }

  if (current_step === 3) {
    $(".product-form__submit ").attr('disabled', 'disabled');
    $('#cookie-maker-continue-btn').hide();
    $('body[class~="template_product.custom-cookie-cake"] .product-form__buttons').show();

  }
}


//EVENTS
main_flavor_selector.on('change', function (evt) {
	limitSelectingOptions(main_flavor_selector);
});

icing_flavor_selector.on('change', function (evt) {
	limitSelectingOptions(icing_flavor_selector);
});

text_area_message.on('change keyup paste', function () {
  cake_message = $(this).val();
  validateAddToCart();
  $('.hidden-cake-message').val(cake_message);
});

cake_message_flavor_selector.on('change', function (evt) {
  cake_message_flavor = $(this).val();
  $('.hidden-message-icing-flavor').val(cake_message_flavor);
  validateAddToCart();
});


back_button.on('click', function (evt) {
	evt.preventDefault();
	goToStep(current_step - 1);
});

continue_button.on('click', function (evt) {
  evt.preventDefault();

  if(continue_button.hasClass("disabled")){
    return false;
  }
  if (current_step === 1) {
    flavors = [];

    $('input.flavor-one-option:checkbox:checked').each(function () {
      flavors.push($(this).val());
    });
    $('.hidden-flavors').val(ConvertListToCommaSeperated(flavors));
  }

  if (current_step === 2) {
    border_icing_flavors = [];
    $('input.border-icing-option:checkbox:checked').each(function () {
      border_icing_flavors.push($(this).val());  
    });

    if(border_icing_flavors.length === 0 ){
      $('.border-icing-flavors-error').css('visibility', 'visible');
      $('.border-icing-flavors-error').html('Please select at least one');
      return;

    }else{
      $('.hidden-border-icing-flavors').val(ConvertListToCommaSeperated(border_icing_flavors));

    }
  }
  
  current_step = current_step + 1;
  goToStep(current_step);
  validateAddToCart();
});






$('.product-form__submit').on('click', function (evt) {
  set_of_options.hide();
  $('.product-form__submit').hide();
  $('#cookie-maker-back-btn').hide();
  $('.product__title').hide();
  $('.product__description').hide();
  $('.cookie-cake-maker-thankyou-message').show();

});





$("document").ready(function(){
  //$("variant-radios").hide();
  
  if($(".custom_attributes").length){
    var dd = $(".custom_attributes").html();
    var arr = dd.split("\n");
    for (var i = 0; i < arr.length; i++){
      //console.log(arr[i]);
    }   
  }
});




